import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TechnologyPage = lazy(() => import('../pages/services/technology/page'));
const HealthcarePage = lazy(() => import('../pages/services/healthcare/page'));
const LogisticsPage = lazy(() => import('../pages/services/logistics/page'));
const FuelRetailPage = lazy(() => import('../pages/services/fuel-retail/page'));
const CapitalAdvisoryPage = lazy(() => import('../pages/services/capital-advisory/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const LeadershipPage = lazy(() => import('../pages/leadership/page'));
const InsightsPage = lazy(() => import('../pages/insights/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/technology',
    element: <TechnologyPage />,
  },
  {
    path: '/services/healthcare',
    element: <HealthcarePage />,
  },
  {
    path: '/services/logistics',
    element: <LogisticsPage />,
  },
  {
    path: '/services/fuel-retail',
    element: <FuelRetailPage />,
  },
  {
    path: '/services/capital-advisory',
    element: <CapitalAdvisoryPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/leadership',
    element: <LeadershipPage />,
  },
  {
    path: '/insights',
    element: <InsightsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;